import React from "react";
import { Subscription } from "../../../../Entities/Subscription";
import { Alert } from "antd";
import { formatPlanName } from "../../../../Utils/planUtils";
import { useAppContext } from "../../../../Context/AppContext/AppContext";
import dayjs from "dayjs";

interface SubscriptionInfoProps {
  subscription: Subscription;
  selectedPlanId: string | null;
}

const SubscriptionInfo: React.FC<SubscriptionInfoProps> = ({
  subscription,
  selectedPlanId,
}) => {
  const { plans } = useAppContext();
  const selectedPlan = plans.find((p) => p._id === selectedPlanId);
  
  const planName = formatPlanName(selectedPlan?.name || "");

  const currentPlanExpiry = dayjs(subscription.endDate).format("DD MMM YYYY");
  const message = (
    <>
      When switching from {planName} to application credit mode, you can
      complete your purchase now. Your new application credit plan will take effect on{" "}
      {currentPlanExpiry}.
    </>
  );

  return (
    <Alert
      type="info"
      showIcon
      message={message}
      className="credit-plan-info"
    />
  );
};

export default SubscriptionInfo;
